/**
 * @file index.tsx
 * @author liuchen(loocliu@tencent.com)
 */

import React, { useCallback, useMemo } from 'react';
import { AddIcon, DeleteIcon } from 'tdesign-icons-react';
import { Button } from 'tdesign-react';

import { IFormItemProps } from '@/components';
import { IPhaseSelector, PhaseSelectorType } from '@/interface';
import { useTypedSelector } from '@/store';

import styles from './index.module.less';
import Item from './item';


interface IFormArrayProps {
  fieldsConfig: IFormItemProps[];
  form: any;
  repeatConfig?: {
    [key: string]: IFormItemProps[];
  };
}

export const CustomPhaseSelector: React.FC<
{
  fieldname: string;
  config: any;
  errors: { [key: string]: any };
  getFieldDecorator: any;
  value: IPhaseSelector[];
  onChange: (value: IPhaseSelector[]) => {};
  disabled?: boolean;
} & IFormArrayProps
> = (props) => {
  const {
    value = [],
    onChange,
    disabled = false,
  } = props;

  const botInfo = useTypedSelector(store => store.bot.botInfo);
  const options = useMemo(() => (botInfo?.phasesNew || []).map((_, idx) => ({
    value: idx,
    label: `人设${idx + 1}`,
  })), [botInfo]);

  const handleClick1 = useCallback(() => {
    onChange([...value, {
      type: PhaseSelectorType.PHASESELECTORTYPE_RANGE,
      rangeMin: 0,
      rangeMax: 100,
      phaseIndex: 0,
    }]);
  }, [onChange, value]);

  return (
    <div className={styles.root}>
      <div style={{ marginBottom: 16 }}>
        <Button disabled={disabled}
          size='small' icon={<AddIcon />} onClick={handleClick1}>新增人设选择器</Button>
      </div>
      {value.map((item, idx) => <div key={idx} className={styles.item}>
        <Item value={item} options={options} disabled={disabled} onChange={(val: IPhaseSelector) => {
          onChange([...value.slice(0, idx), val, ...value.slice(idx + 1)]);
        }} />
        <Button disabled={disabled}
          theme='default' icon={<DeleteIcon />} className={styles.delete} onClick={() => {
            onChange([...value.slice(0, idx), ...value.slice(idx + 1)]);
          }}></Button>
      </div>)}
    </div>
  );
};
